const MAX_FILE_BYTES = 5 * 1024 * 1024;

import { XAT_API, xatAceFrameImageUrl } from '@/services/api-paths';

export async function uploadAvatarFrameImage(frameId: string, file: File): Promise<string> {
  if (file.size > MAX_FILE_BYTES) {
    throw new Error('Imagem demasiado grande (máx. 5 MB).');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('frameId', frameId);

  const res = await fetch(XAT_API.aceFrameUpload(), {
    method: 'POST',
    body: formData,
  });

  const payload = (await res.json().catch(() => ({}))) as { url?: string; error?: string };
  if (!res.ok || !payload.url) {
    throw new Error(payload.error ?? 'Não foi possível enviar a imagem.');
  }

  return payload.url;
}
